// Katalog für den Filter-Editor laden und zwischenspeichern (Agent 5A, Runde 5). Der Katalog ändert sich selten (neue eigene Felder,
// neue Status), deshalb gilt er fünf Minuten und wird beim Wechsel des Nutzers verworfen.
import { useEffect, useState } from "react";
import { filterApi, type FilterKatalog, type FilterObjekt } from "../../api/filter";
import { beimNutzerwechsel } from "../../daten/sitzung";

const GUELTIG_MS = 5 * 60 * 1000;
const speicher = new Map<FilterObjekt, { zeit: number; daten: FilterKatalog }>();
const laufend = new Map<FilterObjekt, Promise<FilterKatalog>>();
beimNutzerwechsel(() => {
  speicher.clear();
  laufend.clear();
});

export function filterKatalogLaden(objekt: FilterObjekt = "lead", frisch = false): Promise<FilterKatalog> {
  const vorhanden = speicher.get(objekt);
  if (vorhanden && !frisch && Date.now() - vorhanden.zeit < GUELTIG_MS) return Promise.resolve(vorhanden.daten);
  const l = laufend.get(objekt);
  if (l) return l;
  const p = filterApi
    .katalog(objekt)
    .then((daten) => {
      speicher.set(objekt, { zeit: Date.now(), daten });
      return daten;
    })
    .finally(() => laufend.delete(objekt));
  laufend.set(objekt, p);
  return p;
}

/** Katalog einer Objektart; `null`, solange er lädt. Ein Fehler steht in `fehler` (der Editor zeigt dann nur die Pillen lesend). */
export function useFilterKatalog(objekt: FilterObjekt = "lead"): { katalog: FilterKatalog | null; fehler: unknown } {
  const [stand, setStand] = useState<{ katalog: FilterKatalog | null; fehler: unknown }>(() => ({ katalog: speicher.get(objekt)?.daten ?? null, fehler: null }));
  useEffect(() => {
    let weg = false;
    filterKatalogLaden(objekt)
      .then((k) => !weg && setStand({ katalog: k, fehler: null }))
      .catch((e) => !weg && setStand((s) => ({ ...s, fehler: e })));
    return () => {
      weg = true;
    };
  }, [objekt]);
  return stand;
}
